/*
 * Copyright (c) 2025 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, October 2nd 2025, 3:43:42 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { EmptyStateActionWrapper, Image } from "ui-widgets";

export const EmptyAgentsCTA = ({ ctaButtons }) => {
  return (
    <>
      <EmptyStateActionWrapper
        title="No agents configured yet"
        description={"You dont have any agents configured to review this form."}
        illustrationGraphic={
          <Image className="image-style-A" src="/img/artificial-intelligence.png" alt="Onestop Admin" />
        }
      >
        {ctaButtons}
      </EmptyStateActionWrapper>
    </>
  );
};
